<template>
  <div class="extra-bonus-intersection">
    <slot />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const extraBonus = namespace('extraBonus')

@Component({})
class ExtraBonusIntersectionObserver extends Vue {
  @Prop({
    type: Boolean,
    required: true
  }) reset

  @Prop({
    type: Object,
    required: true
  }) card

  @Prop({
    type: Number,
    required: true
  }) stateId

  @extraBonus.Action('extraBonusCheck') extraBonusCheck

  mounted () {
    if (this.reset) this.startObserver()
  }

  observer = null

  startObserver () {
    const options = {
      rootMargin: '0px',
      threshold: [ 0.85 ]
    }
    this.observer = new IntersectionObserver(this.intersectionCallback, options)
    this.observer.observe(this.$el)
  }

  stopObserver () {
    this.observer.unobserve(this.$el)
  }

  intersectionCallback (entries, observer) {
    entries.forEach((entry) => {
      const { isIntersecting } = entry
      if (isIntersecting) {
        this.extraBonusCheck({ card: this.card, stateId: this.stateId })
        this.stopObserver()
      }
    })
  }
}
export default ExtraBonusIntersectionObserver
</script>
